import baseApi from "../api/baseApi";

const certificateApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllCertificates: builder.query({
      query: ({ page = 1, limit = 10, search = "", status = "" } = {}) => ({
        url: "/certificate",
        method: "GET",
        credentials: "include",
        params: {
          page,
          limit,
          ...(search ? { search } : {}),
          ...(status ? { status } : {}),
        },
      }),
      providesTags: ["Certificates"],
    }),

    getSingleCertificate: builder.query({
      query: (certificateId) => ({
        url: `/certificate/${certificateId}`,
        method: "GET",
        credentials: "include",
      }),
      providesTags: (result, error, certificateId) => [
        { type: "Certificates", id: certificateId },
      ],
    }),

    revokeCertificate: builder.mutation({
      query: ({ id, reason }) => ({
        url: `/certificate/revoke/${id}`,
        method: "PATCH",
        credentials: "include",
        body: { revokeReason: reason },
      }),
      invalidatesTags: ["Certificates"],
    }),

    restoreCertificate: builder.mutation({
      query: (id) => ({
        url: `/certificate/restore/${id}`,
        method: "PATCH",
        credentials: "include",
      }),
      invalidatesTags: ["Certificates"],
    }),
  }),
});

export const {
  useGetAllCertificatesQuery,
  useGetSingleCertificateQuery,
  useRevokeCertificateMutation,
  useRestoreCertificateMutation,
} = certificateApi;

export default certificateApi;
